import { defaultCountry, findCountryByLocale } from "@/config/markets";
import {
  parsePhoneNumberFromString,
  type CountryCode,
} from "libphonenumber-js";

export function getDefaultPhoneCountry(locale: string): CountryCode {
  return findCountryByLocale(locale.toLowerCase()) ?? defaultCountry;
}

export function normalizePhoneNumber(
  value: string,
  country: CountryCode,
): string | undefined {
  const phoneNumber = parsePhoneNumberFromString(value, country);
  return phoneNumber?.isValid() ? phoneNumber.number : undefined;
}
